<template>
  <div class="selectselfpickupPage">
      <XR-head titleText="选择自提点" :rightShow="true" ref="headObj"></XR-head>
       <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="省市区"  icon=":fa fa-location" labelFloat fullWidth v-model="address" @focus="openBottomSheet" />
          <mu-bottom-sheet :open="bottomSheet" @close="closeBottomSheet">            
            <mu-picker :slots="addressSlots" :visible-item-count="5" @change="addressChange" :values="address" @itemClick="closeBottomSheet"/>
          </mu-bottom-sheet>
        </mu-col>
      </mu-row> 
      <div style="width:100%;height:10%;">
        <mu-icon value=":fa fa-map" style="color:#81818D;height:100%;width:10%;float:left;padding-top:5%;padding-left:4%;"></mu-icon>
        <div style="width:80%;height:50%;float:left;margin-top:5%;margin-left:4%;line-height:30px;font-size:16px;" v-if="selfPickUpList.length>0">
          所选区域共<span style="color:red;">{{selfPickUpList.length}}</span>个自提点，请选择
        </div>
        <div style="width:80%;height:50%;float:left;margin-top:5%;margin-left:4%;line-height:30px;font-size:16px;" v-if="selfPickUpList.length==0">
          所选区域没有自提点
        </div>
      </div>
      <mu-list>
        <template v-for="selfItem in selfPickUpList" :v-if="selfPickUpList.length>0">
          <mu-list-item :title="selfItem.ShopName" :describeText="selfItem.Address" :key="selfItem.ShopId">
          <mu-checkbox style="float:right;top:-20px;" :nativeValue="selfItem.ShopId" v-model="checkList" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes" @change="writenum(selfItem.ShopId, selfItem.ShopName, selfItem.Address)"/>
          </mu-list-item>
        </template>
        <template v-if="selfPickUpList.length==0">
          <mu-list-item style="text-align:center;">{{selfPickUpListDesc}}</mu-list-item>
        </template>
      </mu-list>
    <div class="OKbtn" @click="goOKbtn()">
      确定
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>
<script>
var address = {
  '北京': {'北京':['北京']},
  '湖北': {'武汉':['武昌区','汉阳区','青山区'], '黄石':['黄石']},
  '台湾': {'台北市':['台北市']}
}
export default {
  data () {
    return {
      titleText: this.$route.query.id?'编辑收货地址':'添加收货地址',
      loaded:true,
      password:"",
      temp:{},
      provinceCache:'',
      checkList:[],
      bottomSheet: false,
      selectAddress:'',   
      shopCache:{shopId:""},   
      addressSlots: [
        {
          width: '100%',
          textAlign: 'right',
          values: ['北京']
        }, {
          width: '100%',
          textAlign: 'center',
          values: ['北京市']
        }, {
          width: '100%',
          textAlign: 'left',
          values: ['东城区']
        }
      ],
      address: ['北京', '北京市','东城区'],
      addressProvince: '北京',
      addressCity: '北京市',
      addressArea: '东城区',
      editInfo:{
        ReceiveId: 0,
        Receiver:'',
        Province : '北京',
        City:'北京市',
        Area:'东城区',
        Address:'',
        Phone:'',
        PosCode:''
      },
      selfPickUpList:[],
      selfPickUpListDesc:'',
      skuId:this.$route.query.skuId,
      redirectUrl:this.$route.query.redirectUrl,
      shopId: this.$route.query.shopId
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()   
    this.getDeliveryAreaCache()
    this.getAreaList()
  },
  methods: {    
    getDeliveryAreaCache(){      
      var provinceCache = window.localStorage.ProductDetailDeliveryProvinceCache
      this.provinceCache=provinceCache;
      if(provinceCache){
        this.addressProvince = provinceCache
      }
      var cityCache = window.localStorage.ProductDetailDeliveryCityCache
      if(cityCache){
        this.addressCity = cityCache
      }
      var areaCache = window.localStorage.ProductDetailDeliveryAreaCache
      if(areaCache){
        this.addressArea = areaCache
      }
      this.address = [this.addressProvince, this.addressCity, this.addressArea]
      var tmpShopCache= window.localStorage['SelfPickUpShopInfo']
      console.info(tmpShopCache)
      if(tmpShopCache){
        this.shopCache = JSON.parse(tmpShopCache)
        console.info(1)
        console.info(this.shopCache.shopId)
        this.writenum(this.shopCache.shopId, this.shopCache.shopName, this.shopCache.address)
      }
    },
    getaddress(){
      console.info(this.provinceCache);
    },
    getAreaList(){
      var ths = this;   
      ths.$post(
        "/Shop/BaseServer/GetAreaAllListGroup"
      ).then(function(res) {
        ths.$refs.XRtoast.hide() 
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{     
          address= JSON.parse(res.Data) 
          ths.addressSlots[0].values = Object.keys(address)             
        }
      });
    },        
    GetSelfPickUpSiteShopList(){      
        var ths = this;   
        var data = {
          SkuId:this.skuId,
          Province: this.addressProvince, 
          City: this.addressCity, 
          Area: this.addressArea 
        };
        ths.$post(
          "/Shop/RetailServer/GetSelfPickUpSiteShopList", data
        ).then(function(res) {
          if(res.IsSuccess){
            ths.selfPickUpList = res.Data
          }else{
            ths.selfPickUpList = []
            ths.selfPickUpListDesc = res.Msg
          }
        });
    },
    writenum(shopId, shopName, address){
      this.checkList=[shopId];
      this.temp.shopId=shopId;
      this.temp.shopName=shopName;
      this.temp.address=address;
    },
    addressChange (value, index) {
      switch (index) {
        case 0:
          this.addressProvince = value
          var cirtyList = address[value]
          var keys = Object.keys(cirtyList)          
          this.addressSlots[1].values = keys
          this.addressCity = keys[0]
          
          var areaList = address[this.addressProvince][this.addressCity]        
          this.addressSlots[2].values = areaList
          this.addressArea = areaList[0]
          break
        case 1:      
          this.addressCity = value
          var arr1 = address[this.addressProvince][value]          
          this.addressSlots[2].values = arr1
          this.addressArea = arr1[0]
          break
        case 2:
          this.addressArea = value          
          break
      }

      window.localStorage.ProductDetailDeliveryProvinceCache =this.addressProvince
      window.localStorage.ProductDetailDeliveryCityCache = this.addressCity
      window.localStorage.ProductDetailDeliveryAreaCache = this.addressArea
      this.address = [this.addressProvince, this.addressCity, this.addressArea]
    },
    closeBottomSheet () {
      this.bottomSheet = false
    },
    openBottomSheet () {
      this.bottomSheet = true
    },
    goOKbtn(){
      console.info(this.checkList);
      if(this.checkList.length==0){
      this.$refs.XRtoast.failed('您还未选择自提点',true);
      return;
      }
      this.goOrderSubmit(this.temp.shopId, this.temp.shopName, this.temp.address)
    },
    goOrderSubmit(shopId, shopName, address){
      
      window.localStorage[this.shopId+ 'SelfPickUpShopInfo'] = JSON.stringify({shopId: shopId, shopName: shopName, address:address})
      //window.localStorage['SelfPickUpShopInfo'] = JSON.stringify({shopId: shopId, shopName: shopName, address:address})
      this.$router.goBack()
    }
  },
  watch:{
    address(){    
      if(this.addressProvince != '全部' && this.addressCity != '全部' && this.addressArea != '全部'){
        this.GetSelfPickUpSiteShopList()
      }else{
        this.selfPickUpList = []
        this.selfPickUpListDesc = '请选择省市区'
      }
    }
  }
}
</script>
<style>
  body .selectselfpickupPage{
    background: #fff;
  }
  .selectselfpickupPage .mu-list{
    margin-top: 20px;
    margin-bottom: 57px;
  }
  .selectselfpickupPage .mu-list .mu-item-title{
    font-size: 14px
  }
  .selectselfpickupPage .mu-icon{
    text-align:initial;
  }
  .selectselfpickupPage .OKbtn{
  overflow: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: white;
  border-top: 1px solid #eee;
  line-height: 56px;
  z-index: 4;text-align: center;
  background-color:red;width:100%;height:56px;color:white;font-size:16px;font-weight:400;
  }
</style>




// WEBPACK FOOTER //
// src/pages/retail/SelectSelfPickUp.vue